import $ from 'jquery';

class Tooltip {
	constructor(element) {
		this.element = element;
		this.enable();
	}

	enable() {
		$(this.element).tooltip('enable');
	}
}

export default Tooltip;
